import { createSystem, defaultConfig, defineConfig, SystemContext } from '@chakra-ui/react'
import { adminConfig } from '@src/components/sco/Admin/Layout/adminTheme.ts'
import { animationStyles } from '@src/theme/animation-styles.ts'
import { breakpoints } from '@src/theme/breakpoints.ts'
import { globalCss } from '@src/theme/global-css.ts'
import { keyframes } from '@src/theme/keyframes.ts'
import { layerStyles } from '@src/theme/layer-styles.ts'
import { nextColorPalette, nextConfig } from '@src/theme/next'
import { recipes } from '@src/theme/recipes'
import { slotRecipes } from '@src/theme/slot-recipes'
import { textStyles } from '@src/theme/text-styles.ts'
import { tokens } from '@src/theme/tokens'

const chakraDesignSystem = createSystem(defaultConfig)

const scoConfig = defineConfig({
  preflight: true,
  cssVarsPrefix: 'chakra',
  cssVarsRoot: ':where(:root, :host)',
  theme: {
    animationStyles,
    breakpoints,
    keyframes,
    layerStyles,
    recipes,
    semanticTokens: tokens.semanticTokens,
    slotRecipes,
    textStyles,
    tokens: tokens.tokens,
  },
  globalCss: {
    ...globalCss,
    '.docs-story': {
      // Storybook preview fix
      background: 'var(--chakra-colors-bg)',
    },
  },
})

const scoDesignSystem = createSystem(defaultConfig, scoConfig)

const adminDesignSystem = createSystem(defaultConfig, scoConfig, adminConfig)

// Work-in-progress replacement theme (src/theme/next/README.md)
const nextDesignSystem = createSystem(defaultConfig, scoConfig, nextConfig)

const nextAdminDesignSystem = createSystem(defaultConfig, scoConfig, nextConfig, adminConfig)

const getDesignSystem = (themeKey?: string): SystemContext => {
  const designSystems = {
    admin: adminDesignSystem,
    sco: scoDesignSystem,
    chakra: chakraDesignSystem,
    next: nextDesignSystem,
    'next-admin': nextAdminDesignSystem,
  }
  return designSystems[themeKey] || scoDesignSystem
}

const scoColorPalette = {
  _dark: 'purple',
  _light: 'orange',
}

const getDesignSystemColorPalette = (themeKey?: string) => {
  return themeKey?.startsWith('next') ? nextColorPalette : scoColorPalette
}

export {
  getDesignSystem,
  getDesignSystemColorPalette,
  adminDesignSystem,
  nextDesignSystem,
  scoDesignSystem,
  chakraDesignSystem,
  scoDesignSystem as default,
}
